import React, { useEffect, useState } from 'react';
import Swal from '../librarianSwal';
import { useActiveLibraryId } from '../../Constant/useActiveLibrary';
import Loader from '../../Layout/Loader';
import useMinLoading from '../../Layout/useMinLoading';

import {
  getDepositLedgerByLibrary,
  getErrorMessage
} from '../../api/api';
import '../lib-page-header.css';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 10;

const DepositLedger = ({ embedded = false } = {}) => {
  const libraryId = useActiveLibraryId();

  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(false);
  const showLoader = useMinLoading(loading);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const fetchLedger = async () => {
    try {
      if (!libraryId) return;

      setLoading(true);
      const data = await getDepositLedgerByLibrary(libraryId);
      setLedger(data || []);
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryId]);

  const filteredLedger = ledger.filter((item) => {
    const keyword = search.toLowerCase();

    return (
      String(item.member_name || item.parent_name || '').toLowerCase().includes(keyword) ||
      String(item.ledger_type || item.entry_type || '').toLowerCase().includes(keyword) ||
      String(item.reference_no || item.reference_type || '').toLowerCase().includes(keyword) ||
      String(item.remarks || '').toLowerCase().includes(keyword)
    );
  });

  const totalPages = Math.max(1, Math.ceil(filteredLedger.length / PAGE_SIZE));
  const paginatedLedger = filteredLedger.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  useEffect(() => {
    setPage(1);
  }, [search]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  return (
    <div className="container-fluid mt-3">
      {!embedded && (
        <div className="lib-page-header">
          <div className="lib-page-header__left">
            <div className="lib-page-header__icon">
              <i className="fas fa-wallet" />
            </div>
            <div>
              <h3 className="lib-page-header__title">Deposit Ledger</h3>
              <div className="lib-page-header__subtitle">View membership/security deposit ledger</div>
            </div>
          </div>
        </div>
      )}


      <div className="card shadow-sm mt-3 table-full-card">
        <div className="card-body">
          <div className="row g-2 align-items-center mb-3">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search member, type, reference..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <button type="button" className="btn btn-outline-secondary w-100" onClick={() => setSearch('')}>
                Reset
              </button>
            </div>
          </div>

          {showLoader ? (
            <Loader />
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Member</th>
                    <th>Ledger Type</th>
                    <th>Credit</th>
                    <th>Debit</th>
                    <th>Balance</th>
                    <th>Reference</th>
                    <th>Date</th>
                    <th>Remarks</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedLedger.length > 0 ? (
                    paginatedLedger.map((item, index) => (
                      <tr key={item.id}>
                        <td>{(page - 1) * PAGE_SIZE + index + 1}</td>
                        <td>
                          <strong>{item.member_name || item.parent_name || '-'}</strong>
                          <div className="small text-muted">{item.mobile || '-'}</div>
                        </td>
                        <td>{item.ledger_type || item.entry_type || '-'}</td>
                        <td>₹ {item.credit_amount || 0}</td>
                        <td>₹ {item.debit_amount || 0}</td>
                        <td>₹ {item.balance_amount || 0}</td>
                        <td>{item.reference_no || item.reference_type || '-'}</td>
                        <td>{item.created_at ? String(item.created_at).slice(0, 10) : '-'}</td>
                        <td>{item.remarks || '-'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center text-muted py-4">
                        No deposit ledger found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                page={page}
                totalPages={totalPages}
                totalItems={filteredLedger.length}
                itemLabel="entries"
                onPageChange={setPage}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepositLedger;